export class Insurer {
    id: number;
    name: string;
    phone: string;
    whatsapp: string;
    contact: string;
    email: string;
    active: boolean;
}